// extracted by mini-css-extract-plugin
export default {"wrapper":"pC-z","viewport":"qC-z","container":"rC-z","slide":"sC-z"};